import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              由专业医师团队撰写的最受欢迎科普文章
            </p>
          </div>
          <Link
            to="/category/anatomy"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/anatomy"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}